import { CLIENT_JOBS } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case CLIENT_JOBS.LOAD:
      return {
        ...state,
        loading: true,
      };
    case CLIENT_JOBS.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case CLIENT_JOBS.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
